import { ApolloError, DocumentNode, useLazyQuery } from "@apollo/client";
import { useMemo } from "react";

export type MappedQueryResult<MappedQueryResultRecordType> = {
  loading: boolean;
  error?: ApolloError;
  records?: MappedQueryResultObject<MappedQueryResultRecordType> | MappedQueryResultRecordType[];
  fetchMore?: (options: { variables: any; updateQuery?: any }) => void;
  getClients: any;
};
export type MappedQueryResultObject<T> = {
  [key: string]: T[] | number;
};
export type MapperFunction<QueryResultType, MappedQueryResultRecordType> = (
  queryResult: QueryResultType
) =>
  | MappedQueryResultObject<MappedQueryResultRecordType>
  | MappedQueryResultRecordType[]
  | undefined;

export const useMappedQueryResult = <QueryResultType, MappedQueryResultRecordType>(
  query: DocumentNode,
  mapQueryResultRecords: MapperFunction<QueryResultType, MappedQueryResultRecordType>,
  data?: any
): MappedQueryResult<MappedQueryResultRecordType> => {
  const [getClients, { loading, error, data: dataRes, fetchMore }] = useLazyQuery<QueryResultType>(
    query,
    data && {
      variables: data,
    }
  );

  const records = useMemo(() => (dataRes ? mapQueryResultRecords(dataRes) : undefined), [dataRes]);
  return { loading, error, records, fetchMore, getClients };
};
